export function generateRangeTo(max?: number) {
  if (max) {
    return [0, ...Array.from({ length: max }, (_, i) => i + 1)]
  }
  return [0, 1]
}
